export const GOOGLE_API_KEY = 'AIzaSyCAIsBcY3Vp02QzqEYArhDp59tcmqZeGPw';
export const TIMEZONE_API_KEY = 'AIzaSyDeIR19zSuEUVfI2MOhqbN-_aMH3tLXc5A';
export const HOST = ((window.location.href.match('dev') || !window.location.href.match('appspot'))
  ? 'https://pm-heatmap-backend-dev-dot-focused-history-278517.uc.r.appspot.com'
  : 'https://pm-heatmap-backend-dot-focused-history-278517.uc.r.appspot.com');
